export default __webpack_public_path__ + "static/media/404.32eaf5e4.png";